import {
  selectOperationState,
  clearOperation as clearOperationAction,
  clearResult as clearResultAction,
} from "../store/appSlice";

import {
  LOADING_STATE,
  ERROR_STATE,
  SUCCESS_STATE,
} from "../constants/operationsState";

import { useSelector, useDispatch } from "react-redux";
import { useDeepCompareCallback } from "../hooks/deepComparison";

export function useOperationState(path, { defaultLoading = false } = {}) {
  const state = useSelector(selectOperationState(path)) || {};
  const dispatch = useDispatch();
  const clearOperation = useDeepCompareCallback(() => {
    dispatch(clearOperationAction(path));
  }, [dispatch, path]);

  const clearResult = useDeepCompareCallback(() => {
    dispatch(clearResultAction(path));
  }, [dispatch, path]);

  return {
    operationLoading:
      state.type === LOADING_STATE ? true : !state.type && defaultLoading,
    operationError: state.type === ERROR_STATE ? state.error : null,
    operationSuccess: state.type === SUCCESS_STATE,
    clearOperation,
    clearResult,
  };
}
